<template>
  <div class="wrapper">
    <div class="wrapper_t">
      <div style="padding: 10px">
        <el-form label-width="60px">
          <el-col :span="4">
            <el-form-item label="学校">
              <el-select
                v-model="school"
                placeholder="请选择学校"
                @change="schoolChange()"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in schoolList"
                  :key="item.school_code"
                  :label="item.name"
                  :value="item.school_code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="年级">
              <el-select
                v-model="grade"
                placeholder="请选择年级"
                @change="gradeChange()"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="学科" prop="region">
              <el-select
                v-model="subject"
                placeholder="请选择学科"
                @change="subjectChange()"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in subjectList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态" prop="region">
              <el-select
                v-model="state"
                placeholder="请选择状态"
                @change="stateChange()"
              >
                <el-option label="全部" value="0"></el-option>
                <el-option label="进行中" value="2"></el-option>
                <el-option label="待开始" value="1"></el-option>
                <el-option label="已结束" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="筛选" prop="region" style="display:none;">
              <el-select v-model="se" placeholder="全部" @change="seChange()">
                <el-option label="全部" value="0"></el-option>
                <el-option label="我发布的" value="1"></el-option>
                <el-option label="我参加的" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="4">
            <el-input
              placeholder="请输入关键字"
              suffix-icon="el-icon-search"
              v-model="keyStr"
              @change="nameChange"
            >
            </el-input>
          </el-col>
        </el-form>
      </div>
      <div style="padding: 10px; margin-top: 50px">
        <el-form :inline="true">
          <el-form-item label="自定义日期">
            <el-date-picker
              v-model="startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="~">
            <el-date-picker
              v-model="endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding: 10px">
        <div v-for="item in activityList" :key="item.id" class="activity-item">
          <div style="display: flex; padding: 10px; width: 100%">
            <div v-if="item.state == 1" class="left-img left-img1">
              <i class="el-icon-document"></i>
            </div>
            <div v-if="item.state == 2" class="left-img left-img2">
              <i class="el-icon-document"></i>
            </div>
            <div v-if="item.state == 3" class="left-img left-img3">
              <i class="el-icon-document"></i>
            </div>
            <div style="margin-left: 15px">
              <div class="name">
                <span v-if="item.isLecturer" style="color: #409eff">（我是主讲）</span>
                <span v-else-if="item.isOwn" style="color: #409eff"
                  >（我创建的）</span
                >{{ item.name }}
              </div>
              <div>
                类型：{{
                  item.type == 1
                    ? "听课评课"
                    : item.type == 2
                    ? "集体备课"
                    : "教研会议"
                }}
              </div>
              <div>
                学校：{{ item.from }} 丨 年级：{{ item.gradeName }} 丨 学科：{{ item.subjectName }}
              </div>
              <div>活动时间：{{ item.startTime + " - " + item.endTime }}</div>
            </div>
          </div>
          <div class="op">
            <div style="cursor: pointer" @click="showFile(item)">
              <i v-if="!item.showFile" class="el-icon-arrow-down"></i>
              <i v-else class="el-icon-arrow-up"></i>
              <span style="color: #606266"
                >包含资料：{{ item.fileList.length }}</span
              >
            </div>
            <div style="flex: 1; text-align: right">
              <span @click="deleteActivity(item.uuid)" v-if="item.isOwn && type != 4"
                >删除</span
              >
              <span
                @click="toEdit(item.uuid,item.type)"
                v-if="item.isOwn && type != 4"
                >编辑</span
              >
              <span @click="toDetail(item)">详情</span>
            </div>
          </div>
          <div v-if="item.showFile">
            <div
              v-for="(item_f, index_f) in item.fileList"
              :key="'f' + index_f"
            >
              <div v-if="index_f != 0" class="line"></div>
              <div class="file">
                <div>
                  <img
                    v-if="
                      item_f.type == 'png' ||
                      item_f.type == 'jpg' ||
                      item_f.type == 'gif' ||
                      item_f.type == 'jpeg'
                    "
                    src="../../assets/images/course_2.0/图片.png"
                    class="
                      add_course_info_content_box_content_item_img_homework
                    "
                    alt=""
                  />
                  <img
                    v-if="item_f.type == 'pdf' || item_f.type == 'PDF'"
                    src="../../assets/images/course_2.0/pdf.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="
                      item_f.type == 'ppt' ||
                      item_f.type == 'pptx' ||
                      item_f.type == 'PPT' ||
                      item_f.type == 'PPTX'
                    "
                    src="../../assets/images/course_2.0/PPT.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="
                      item_f.type == 'doc' ||
                      item_f.type == 'DOC' ||
                      item_f.type == 'docx' ||
                      item_f.type == 'DOCX'
                    "
                    src="../../assets/images/course_2.0/word.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="item_f.type == 'xls' || item_f.type == 'xlsx'"
                    src="../../assets/images/course_2.0/excel.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="item_f.type == 'mp3' || item_f.type == 'MP3'"
                    src="../../assets/images/course_2.0/音频.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="
                      item_f.type == 'mp4' ||
                      item_f.type == 'MP4' ||
                      item_f.type == 'wmv' ||
                      item_f.type == 'WMV' ||
                      item_f.type == 'mpg' ||
                      item_f.type == 'MPG' ||
                      item_f.type == 'avi' ||
                      item_f.type == 'AVI' ||
                      item_f.type == 'swf' ||
                      item_f.type == 'SWF' ||
                      item_f.type == 'flv' ||
                      item_f.type == 'FLV'
                    "
                    src="../../assets/images/course_2.0/视频.png"
                    class="
                      add_course_info_content_box_content_item_img_homework
                    "
                    alt=""
                  />
                </div>
                <div class="file-name">{{ item_f.name }}</div>
                <div class="file-btn" @click="download(item_f)">下载</div>
                <div class="file-btn" @click="preview(item_f)">预览</div>
              </div>
            </div>
          </div>
          <div v-if="item.state == 1" class="state state1">待开始</div>
          <div v-if="item.state == 2" class="state state2">进行中</div>
          <div v-if="item.state == 3" class="state state3">已结束</div>
        </div>
        <el-empty
          v-if="activityList.length == 0"
          description="暂无数据"
        ></el-empty>
      </div>
    </div>
    <div class="wrapper_r">
      <div class="bt bt1" @click="toEdit('0', 1)" v-if="type==0">
        <div><i class="el-icon-circle-plus-outline"></i></div>
        <div>听课评课</div>
      </div>
      <div class="bt bt1" @click="toEdit('0', 2)" v-if="type==0">
        <div><i class="el-icon-circle-plus-outline"></i></div>
        <div>集体备课</div>
      </div>
      <div class="bt bt1" @click="toEdit('0', 3)" v-if="type==0">
        <div><i class="el-icon-circle-plus-outline"></i></div>
        <div>教研会议</div>
      </div>
      <div :class="isMyActivity?' bt bt1 selected':' bt bt1'" @click="myActivity" v-if="type==1 || type==3 || type == 4">
        <div><i class="el-icon-user"></i></div>
        <div>我是主讲</div>
      </div>
      <div class="bt bt1" @click="researchCalendar">
        <div><i class="el-icon-date"></i></div>
        <div>教研日历</div>
      </div>
      <div class="bt bt2" style="display: none">
        <div><i class="el-icon-bank-card"></i></div>
        <div>发布记录</div>
      </div>
      <div class="bt bt2" @click="toNote" v-if="type==1 || type == 4">
        <div><i class="el-icon-notebook-1"></i></div>
        <div>我的笔记</div>
      </div>
    </div>

    <!--  -->
    <el-drawer
      title="教研活动日历"
      :visible.sync="calendarDialogVisible"
      direction="rtl"
      :size="800"
      :modal="false"
    >
      <div style="padding: 20px">
        <el-calendar v-model="calendarValue">
          <template slot="dateCell" slot-scope="{ date, data }">
            <div class="calendar-item" @click="calendarClick(data.day)">
              <div>{{ data.day.split('-').slice(1).join('-') }}</div>
              <div v-if="activityList.filter(x=>x.date==data.day && x.type==1).length>0">
                听课评课*{{activityList.filter(x=>x.date==data.day && x.type==1).length}}
              </div>
              <div v-if="activityList.filter(x=>x.date==data.day && x.type==2).length>0">
                集体备课*{{activityList.filter(x=>x.date==data.day && x.type==2).length}}
              </div>
              <div v-if="activityList.filter(x=>x.date==data.day && x.type==3).length>0">
                教研会议*{{activityList.filter(x=>x.date==data.day && x.type==3).length}}
              </div>
            </div>
          </template>
        </el-calendar>
        <div>
          <div v-for="item in dateActivityList" :key="item.id" class="activity-item">
          <div style="display: flex; padding: 10px; width: 100%">
            <div v-if="item.state == 1" class="left-img left-img1">
              <i class="el-icon-document"></i>
            </div>
            <div v-if="item.state == 2" class="left-img left-img2">
              <i class="el-icon-document"></i>
            </div>
            <div v-if="item.state == 3" class="left-img left-img3">
              <i class="el-icon-document"></i>
            </div>
            <div style="margin-left: 15px">
              <div class="name">
                <span v-if="item.isOwn" style="color: #409eff"
                  >（我创建的）</span
                >{{ item.name }}
              </div>
              <div>
                类型：{{
                  item.type == 1
                    ? "听课评课"
                    : item.type == 2
                    ? "集体备课"
                    : "教研会议"
                }}
              </div>
              <div>
                学校：{{ item.from }} 丨 年级：{{ item.gradeName }} 丨 学科：{{ item.subjectName }}
              </div>
              <div>活动时间：{{ item.startTime + " - " + item.endTime }}</div>
            </div>
          </div>
          <div class="op">
            <div style="cursor: pointer" @click="showFile2(item)">
              <i v-if="!item.showFile2" class="el-icon-arrow-down"></i>
              <i v-else class="el-icon-arrow-up"></i>
              <span style="color: #606266"
                >包含资料：{{ item.fileList.length }}</span
              >
            </div>
            <div style="flex: 1; text-align: right">
              <span @click="deleteActivity(item.uuid)" v-if="item.isOwn"
                >删除</span
              >
              <span
                @click="toEdit(item.uuid,item.type)"
                v-if="item.isOwn && item.state != 3"
                >编辑</span
              >
              <span @click="toDetail(item)">详情</span>
            </div>
          </div>
          <div v-if="item.showFile2">
            <div
              v-for="(item_f, index_f) in item.fileList"
              :key="'f' + item_f.id"
            >
              <div v-if="index_f != 0" class="line"></div>
              <div class="file">
                <div>
                  <img
                    v-if="
                      item_f.type == 'png' ||
                      item_f.type == 'jpg' ||
                      item_f.type == 'gif' ||
                      item_f.type == 'jpeg'
                    "
                    src="../../assets/images/course_2.0/图片.png"
                    class="
                      add_course_info_content_box_content_item_img_homework
                    "
                    alt=""
                  />
                  <img
                    v-if="item_f.type == 'pdf' || item_f.type == 'PDF'"
                    src="../../assets/images/course_2.0/pdf.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="
                      item_f.type == 'ppt' ||
                      item_f.type == 'pptx' ||
                      item_f.type == 'PPT' ||
                      item_f.type == 'PPTX'
                    "
                    src="../../assets/images/course_2.0/PPT.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="
                      item_f.type == 'doc' ||
                      item_f.type == 'DOC' ||
                      item_f.type == 'docx' ||
                      item_f.type == 'DOCX'
                    "
                    src="../../assets/images/course_2.0/word.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="item_f.type == 'xls' || item_f.type == 'xlsx'"
                    src="../../assets/images/course_2.0/excel.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="item_f.type == 'mp3' || item_f.type == 'MP3'"
                    src="../../assets/images/course_2.0/音频.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    v-if="
                      item_f.type == 'mp4' ||
                      item_f.type == 'MP4' ||
                      item_f.type == 'wmv' ||
                      item_f.type == 'WMV' ||
                      item_f.type == 'mpg' ||
                      item_f.type == 'MPG' ||
                      item_f.type == 'avi' ||
                      item_f.type == 'AVI' ||
                      item_f.type == 'swf' ||
                      item_f.type == 'SWF' ||
                      item_f.type == 'flv' ||
                      item_f.type == 'FLV'
                    "
                    src="../../assets/images/course_2.0/视频.png"
                    class="
                      add_course_info_content_box_content_item_img_homework
                    "
                    alt=""
                  />
                </div>
                <div class="file-name">{{ item_f.name }}</div>
                <div class="file-btn" @click="download(item_f)">下载</div>
                <div class="file-btn" @click="preview(item_f)">预览</div>
              </div>
            </div>
          </div>
          <div v-if="item.state == 1" class="state state1">待开始</div>
          <div v-if="item.state == 2" class="state state2">进行中</div>
          <div v-if="item.state == 3" class="state state3">已结束</div>
        </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      :title="'预览：' + prew_content.name"
      :visible.sync="dialogVisible_previewData"
      width="50%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
    >
      <previewData
        v-if="dialogVisible_previewData"
        :prew_type="prew_type"
        :prew_content="prew_content"
      ></previewData>
    </el-dialog>
  </div>
</template>

<script>
import { isEnabled } from "screenfull";
import previewData from "../../components/common_module/preview_data.vue";
export default {
  components: { previewData },
  data() {
    return {
      type:0,
      userInfo: "",
      currTime: new Date(),
      schoolList:[],
      school: "",
      gradeList: [
        { id: 11, name: "小学一年级" },
        { id: 12, name: "小学二年级" },
        { id: 13, name: "小学三年级" },
        { id: 14, name: "小学四年级" },
        { id: 15, name: "小学五年级" },
        { id: 16, name: "小学六年级" },
        { id: 21, name: "初一" },
        { id: 22, name: "初二" },
        { id: 23, name: "初三" },
        { id: 31, name: "高一" },
        { id: 32, name: "高二" },
        { id: 33, name: "高三" },
      ],
      grade: "",
      subjectList: [],
      subject: "",
      state: "0",
      se: "0",
      keyStr: "",
      dialogVisible_previewData: false,
      previewFile: {},
      activityList: [],
      prew_content: "",
      prew_type: "",
      page: 1,
      timeOut: null,
      startDate: "",
      endDate: "",
      calendarDialogVisible: false,
      calendarValue: new Date(),
      dateActivityList:[],
      isMyActivity:false
    };
  },
  //监听路由变化 控制首页背景图
  watch: {
    $route(to, from) { 
      if(to.params.type!=from.params.type){
        this.type=to.params.type;
        this.isMyActivity=false;
        this.getData();
      }
else
{
        this.type=0;
        this.isMyActivity=false;
        this.getData();
}
    }
  },
  created() {
    if (this.$route.params.type) {
      this.type = this.$route.params.type;
    }
  },

  beforeMount() {},
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo);
    this.getSchool();
  },
  methods: {
    schoolChange() {
      this.getData();
    },
    gradeChange() {
      this.getData();
    },
    subjectChange() {
      this.getData();
    },
    stateChange() {
      this.getData();
    },
    seChange() {
      this.getData();
    },
    nameChange() {
      if (this.timeOut != null) {
        window.clearTimeout(this.timeOut);
        this.timeOut = null;
      }
      this.timeOut = window.setTimeout(this.getData(), 300);
    },
    onSubmit() {
      this.getData();
    },
    onReset() {
      this.startDate = "";
      this.endDate = "";
      this.getData();
    },
    getSchool(){
      this.axios.post(`https://www.gaokaowin.com/proxy2/cloud/cloud/school_list`, {}).then((res) => {
        this.schoolList = res.data.data.data;
        this.getSubject();
      });
    },
    getSubject() {
      this.axios.post(`/teacher/subject/getsubject`, {}).then((res) => {
        this.subjectList = res.data.data;
        this.getData();
      });
    },
    getData() {
      var newEndDate=this.endDate?this.endDate+' 23:59:59':'';
      let formData = {
        current_page: this.page,
        page_size: 1000,
        grade: this.grade,
        school_code: this.school,
        subject: this.subject,
        state: this.state,
        //select: this.se,
        name: this.keyStr,
        startDate:this.startDate,
        endDate:newEndDate,
      };
      if(this.type!=0 && this.type != 4){
        formData.type=this.type;
      }
      if(this.isMyActivity){
        formData.myActivity=this.isMyActivity;
      }
      this.axios.post(`/teacher/research/activityList`, formData).then((res) => {
        var list = res.data.data.data;
        console.log(list);
        list.forEach((element) => {
          element.showFile = false;
          element.showFile2=false;
          var startTime = new Date(element.start_time);
          var endTime = new Date(element.end_time);
          if (startTime > this.currTime) {
            element.state = 1;
          } else if (endTime < this.currTime) {
            element.state = 3;
          } else {
            element.state = 2;
          }
          element.startTime = this.format(startTime);
          element.endTime = this.format(endTime);
          element.gradeName = this.gradeList.find(
            (x) => x.id == element.grade
          ).name;
          element.subjectName = this.subjectList.find(
            (x) => x.code == element.subject_code
          ).name;
          element.fileList.forEach((x) => {
            x.type = x.ext;
          });
          element.isOwn = element.teacher_uuid == this.userInfo.uuid;
          element.isLecturer = element.lecturer_uuid == this.userInfo.uuid;
          element.date=this.format2(startTime);
          this.processing(element.courseList);
          element.courseList.forEach(x=>{
            x.fileList.forEach(y=>{
              element.fileList.push({name:y.name,url:y.url,type:y.type})
            })
          })
        });
        this.activityList = list;
        // if (this.state != 0) {
        //   var tempList = [];
        //   list.forEach((x) => {
        //     if (x.state == this.state) {
        //       tempList.push(x);
        //     }
        //   });
        //   this.activityList = tempList;
        // } else {
        //   this.activityList = list;
        // }
      });
    },
    processing(list) {
      for (var i = 0; i < list.length; i++) {
        try {
          list[i].b_uuid = JSON.parse(list[i].content).b.uuid.length;
          list[i].b_f = JSON.parse(list[i].content).b.f;
          list[i].m_uuid = JSON.parse(list[i].content).m.uuid.length;
          list[i].m_f = JSON.parse(list[i].content).m.f.length;
          list[i].a_f = JSON.parse(list[i].content).a.f;
          list[i].a_uuid = JSON.parse(list[i].content).a.uuid.length;
          list[i].m_file = JSON.parse(list[i].content).m.f;
          list[i].fileList = list[i].b_f.concat(list[i].a_f).concat(list[i].m_file);
        } catch (error) {
          list[i].b_uuid = 0;
          list[i].b_f = [];
          list[i].a_uuid = 0;
          list[i].a_f = 0;
          list[i].m_uuid = 0;
          list[i].fileList=[];
        }
      }
    },
    showFile(item) {
      item.showFile = !item.showFile;
    },
    showFile2(item) {
      item.showFile2 = !item.showFile2;
    },
    toDetail(item) {
      if(item.type==2){
        this.$router.push({
          name: "/research_class_detail",
          params: {
            type: this.type,
            uuid:item.uuid
          },
        });
      }else{
        this.$router.push({
          name: "/research_detail",
          params: {
            type: this.type,
            uuid:item.uuid
          },
        });
      }
      
    },
    toEdit(uuid,type) {
      if(type == 1){
        this.$router.push({
          name: "/research_edit",
          params: {
            type: this.type,
            uuid: uuid
          },
        });
      }else if(type == 2){
        this.$router.push({
          name: "/research_class",
          params: {
            type: this.type,
            uuid: uuid
          },
        });
      }else if(type == 3){
       this.$router.push({
          name: "/research_meeting",
          params: {
            type: this.type,
            uuid: uuid
          },
        });
      }
    },
    deleteActivity(uuid) {
      this.$confirm(
        "删除后所有活动数据资料将一并删除，是否确认删除本次教研活动?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .post(`/teacher/research/delActivity`, { uuid: uuid })
            .then((res) => {
              this.getData();
            });
        })
        .catch(() => {});
    },
    download(item) {
      this.download_material(item);
    },

    researchCalendar() {
      this.calendarDialogVisible = true;
    },
    myActivity(){
      this.isMyActivity=!this.isMyActivity;
      this.getData();
    },
    toNote() {
      this.$router.push("/research/note");
    },
    preview(item) {
       item.url = item.url.indexOf("http://") > -1 || item.url.indexOf("https://") > -1
          ? item.url
          : sessionStorage.url + item.url;
      this.prew_material(item);
    },
    download_material(item) {
      console.log(item);
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
         item.url.indexOf("http://") > -1 || item.url.indexOf("https://") > -1
          ? item.url
          : sessionStorage.url + item.url,
        true
      );
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          var link = document.createElement("a");
          var body = document.querySelector("body");
          link.href = window.URL.createObjectURL(xhr.response);
          link.download = item.name;
          link.style.display = "none";
          // link.target = "_blank";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }
      };
      xhr.send();
    },
    prew_material(item) {
      // return
      if (
        item.type == "mp4" ||
        item.type == "MP4" ||
        item.type == "avi" ||
        item.type == "AVI" ||
        item.type == "flv" ||
        item.type == "FLV" ||
        item.type == "SWF" ||
        item.type == "swf" ||
        item.type == "mpg" ||
        item.type == "MPG" ||
        item.type == "wmv" ||
        item.type == "WMV"
      ) {
        this.prew_type = "mp4";
      } else if (
        item.type == "png" ||
        item.type == "PNG" ||
        item.type == "jpg" ||
        item.type == "JPG" ||
        item.type == "jpeg" ||
        item.type == "JPEG"
      ) {
        this.prew_type = "img";
      } else if (
        item.type == "doc" ||
        item.type == "DOC" ||
        item.type == "docx" ||
        item.type == "DOCX" ||
        item.type == "ppt" ||
        item.type == "PPT" ||
        item.type == "pptx" ||
        item.type == "PPTX" ||
        item.type == "xls" ||
        item.type == "xlsx"
      ) {
        this.prew_type = "ppt";
      } else if (item.type == "mp3" || item.type == "MP3") {
        this.prew_type = "mp3";
      } else if (item.type == "pdf" || item.type == "PDF") {
        this.prew_type = "pdf";
      }

      this.prew_content = item;
      this.dialogVisible_previewData = true;
    },
    format(dat) {
      //获取年月日，时间
      var year = dat.getFullYear();
      var mon =
        dat.getMonth() + 1 < 10
          ? "0" + (dat.getMonth() + 1)
          : dat.getMonth() + 1;
      var data = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
      var hour = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
      var min =
        dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
      var seon =
        dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();

      var newDate = year + "-" + mon + "-" + data + " " + hour + ":" + min;
      return newDate;
    },
    format2(dat) {
      //获取年月日，时间
      var year = dat.getFullYear();
      var mon =
        dat.getMonth() + 1 < 10
          ? "0" + (dat.getMonth() + 1)
          : dat.getMonth() + 1;
      var data = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
      var hour = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
      var min =
        dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
      var seon =
        dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();

      var newDate = year + "-" + mon + "-" + data;
      return newDate;
    },
    calendarClick(date) {
      this.dateActivityList=this.activityList.filter(x=>x.date==date)
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin: 0px auto;
  height: calc(100vh - 142px);
  overflow: auto;
  width: 75vw;
  padding-top: 10px;
  position: relative;
}
.wrapper_t {
  width: calc(100% - 8vw);
  height: calc(100% - 8px);
  background: white;
  border-radius: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}
.wrapper_r {
  position: absolute;
  right: 20px;
  top: 60px;
}
.wrapper_r .bt {
  border: #dcdfe6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  font-size: 14px;
  width: 60px;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  padding: 5px;
  cursor: pointer;
}
.wrapper_r i {
  font-size: 18px;
}
.wrapper_r .bt1 {
  color: #409eff;
}
.wrapper_r .bt2 {
  color: #67c23a;
}
.wrapper_r .selected {
  background-color: #409eff;
  color: white;
}
.activity-item {
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  position: relative;
  font-size: 14px;
  margin-bottom: 10px;
}
.activity-item .name {
  color: #303133;
  font-weight: bold;
}
.activity-item .left-img {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-size: 24px;
}
.activity-item .left-img1 {
  border: 1px solid #e6a23c;
  color: #e6a23c;
}
.activity-item .left-img2 {
  border: 1px solid #67c23a;
  color: #67c23a;
}
.activity-item .left-img3 {
  border: 1px solid #f56c6c;
  color: #f56c6c;
}
.activity-item .state {
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 20px;
  border-top-right-radius: 10px;
  padding: 5px 15px;
  font-size: 12px;
}
.activity-item .state1 {
  color: #409eff;
  border: 1px solid #409eff;
}
.activity-item .state2 {
  color: white;
  background-color: #409eff;
}
.activity-item .state3 {
  color: white;
  background-color: #909399;
}
.activity-item .op {
  background-color: #f2f6fc;
  display: flex;
  padding: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.activity-item .op span {
  color: #409eff;
  margin-left: 20px;
  cursor: pointer;
}
.activity-item .op i {
  font-size: 18px;
}
.activity-item .file {
  display: flex;
  padding: 10px;
  align-items: center;
}
.activity-item .file .file-name {
  flex: 1;
  color: #303133;
  margin-left: 5px;
}
.activity-item .file .file-btn {
  color: #409eff;
  margin-left: 20px;
  cursor: pointer;
}
.activity-item .line {
  border-top: 1px solid #ebeef5;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 26px;
  height: 22px;
}
.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 22px;
  height: 26px;
}
.calendar-item{
  font-size: 12px;
  height: 100%;
}
</style>
